import React from "react";
import {
  Col,
  Card,
  CardHeader,
  Row,
  Button,
  FormGroup,
  Alert,
  FormInput,
} from "../../components/ui";
import { getAllEnabledProductsBilling, validateCoupon } from "../../api";

export default class PlansCardsFilterable extends React.Component {
  constructor(props) {
    super(props);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const couponFromUrl = params.get("coupon");
    this.state = {
      products: [],
      showCouponError: false,
      couponError: "",
      coupon: couponFromUrl,
      appliedCoupons: [],
    };
  }

  componentDidMount = async () => {
    const products = await getAllEnabledProductsBilling();
    if (this.props.isEnded) {
      this.setState({ products: products.data });
    } else {
      this.setState({ products: this.filterUpgrade(products.data) });
    }

    if (this.state.coupon) {
      this.applyCoupon();
    }
  };

  plan = (billingCycle) => {
    if (billingCycle === 12 || billingCycle === 365) {
      return { name: "Yearly", interval: "per year" };
    } else if (billingCycle === 1 || billingCycle === 30) {
      return { name: "Monthly", interval: "per month" };
    } else if (billingCycle === 3 || billingCycle === 92) {
      return { name: "Quarterly", interval: "per quarter" };
    } else if (billingCycle === 65535) {
      return { name: "LifeTime", interval: "LifeTime" };
    } else {
      return {};
    }
  };

  filterUpgrade = (products) => {
    let billingCycleForCurrentProduct = products.filter(
      (p) => p.id === this.props.filterForProduct
    )[0].billingCycle;
    return products.filter(
      (p) => p.billingCycle > billingCycleForCurrentProduct
    );
  };

  applyCoupon = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    let productIds = [];
    this.state.products.map((data) => {
      productIds.push(data.id);
    });
    this.setState(
      {
        appliedCoupons: [],
      },
      () => {
        const coupons = this.state.appliedCoupons;
        let data = {
          couponName: this.state.coupon,
          productIds: productIds,
          userId: user.id,
        };
        if (this.state.coupon) {
          const resp = validateCoupon(data).then((resp) => {
            if (resp && resp.data) {
              resp.data.map((item) => {
                if (item) {
                  coupons.push(item);
                  this.setState({
                    coupons: coupons,
                  });
                }
              });
            }
          });
        }
      }
    );
  };

  checkDiscount = (plan) => {
    let discountedPlan = this.state.appliedCoupons.filter(
      (c) => c.productId === plan.id
    );
    if (discountedPlan.length > 0) {
      return (
        <>
          <h4
            style={{
              color: "#29293A",
              fontSize: 40,
              lineHeight: "52px",
              fontStyle: "normal",
              fontWeight: "bold",
              textTransform: "uppercase",
              textDecoration:
                discountedPlan[0].applicable === false
                  ? "none"
                  : "line-through",
            }}
          >
            ${plan.cost}
          </h4>
          <h4
            style={{
              color: "#29293A",
              fontSize: 40,
              lineHeight: "52px",
              fontStyle: "normal",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            {discountedPlan[0].applicable === false ? (
              <label
                style={{
                  color: "red",
                  fontSize: 12,
                }}
              >
                Coupon not applicable
              </label>
            ) : (
              "$" + discountedPlan[0].discountedCost
            )}
          </h4>
        </>
      );
    } else {
      return (
        <h4
          style={{
            color: "#29293A",
            fontSize: 40,
            lineHeight: "52px",
            fontStyle: "normal",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          ${plan.cost}
        </h4>
      );
    }
  };

  render() {
    return (
      <>
        <Row>
          <Col md={3} lg={3}>
            <FormGroup>
              <FormGroup className="form-group">
                <label htmlFor="feCurrPass">Enter coupon</label>
                <FormInput
                  type="text"
                  placeholder="Coupon code"
                  value={this.state.coupon}
                  onChange={(text) =>
                    this.setState({ coupon: text.target.value })
                  }
                />
                <Button
                  theme="accent"
                  className="btn-blue"
                  onClick={this.applyCoupon}
                >
                  Apply
                </Button>
                {this.state.showCouponError && (
                  <Alert className="mb-0">
                    <i className="fa fa-error mx-2"></i>
                    {this.state.couponError}
                  </Alert>
                )}
              </FormGroup>
            </FormGroup>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {this.state.products.map((plan, idx) => (
            <Col md={{ size: 3 }}>
              <Card
                small
                style={{
                  backgroundColor: this.props.bg,
                  boxShadow: "none",
                  minHeight: 510,
                  marginLeft: "auto",
                  marginBottom: "auto",
                }}
              >
                <CardHeader
                  className="text-center"
                  style={{ backgroundColor: this.props.bg }}
                >
                  <h5
                    style={{
                      color: "#FAA713",
                      fontSize: 14,
                      fontStyle: "normal",
                      textTransform: "uppercase",
                      paddingBottom: 22,
                    }}
                  >
                    {plan.name.toUpperCase()}
                  </h5>
                  <Button
                    pill
                    outline
                    size="sm"
                    className="mb-2"
                    style={{
                      border: "#BE00FF",
                      backgroundColor: "#F8E5FF",
                      color: "#BE00FF",
                    }}
                  >
                    {plan.marketingPhrase}{" "}
                  </Button>
                  {this.checkDiscount(plan)}
                  <span className="text-muted d-block mb-2">
                    {this.plan(plan.billingCycle).interval}
                  </span>
                </CardHeader>
                <div
                  className={"plan-description"}
                  style={{
                    paddingLeft: 24,
                    paddingRight: 24,
                    textAlign: "center",
                    flexGrow: 1,
                    color: "#868e96",
                  }}
                >
                  {plan.description}
                </div>
                <Button
                  style={style.defaultBtn}
                  className="btn-blue"
                  onClick={() =>
                    this.props.changePlan(plan.id, this.state.coupon)
                  }
                >
                  {this.props.actionText}
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}

const style = {
  defaultBtn: {
    margin: 25,
    paddingTop: 10,
    paddingBottom: 16,
    fontSize: 16,
    lineHeight: "28px",
    border: "none",
    color: "white",
    textAlign: "center",
    marginBottom: 25,
  },
};
